export default __webpack_public_path__ + "static/media/doc.f4fd8d5f.svg";